export enum AppActions {
    INIT_STORE = 'initStore',
    SET_LOADING = 'setLoading',
    SET_ADDRESS = 'setAddress',
    DELETE_ADDRESS = 'deleteAddress',
    ERROR = 'setError',
    SET_TARIFFS = 'setTariffs',
    SET_FAMILY_AND_FRIENDS = 'setFamilyFriends',
    SET_ACTIVE_PRODUCT_TYPE = 'setActiveProductType',
    SET_SELECTED_TARIFF = 'setSelectedTariffId',
    SET_GIGAKOMBI = 'setGigakombi',
    SET_AVC_RESULT = 'setAvcResult',
    TRIGGER_REDIRECT = 'triggerRedirect',
    OVERLAY_LOADED = 'overlayLoaded',
    OPEN_OVERLAY = 'openOverlay',
    CLOSE_OVERLAY = 'closeOverlay',
    SET_ACTIVE_OVERLAY = 'setActiveOverlay',
    RESET_PROVIDER = 'resetProviderToDefault',
    RESET_TARIFFS = 'resetOffersToPreVp',
    SET_USER_INFO = 'setUserInfo',
    OpenAutoOverlay= 'openAutoOverlay',
    SET_PRE_MARKETING = 'setPreMarketing',
}

export enum OverlayError {
    CONFIG_MISSING_AVC = 'AVC config object not found',
    CONFIG_MISSING_LM = 'LM config object not found',
    OVERLAY_MISSING = 'Overlay object not found'
}

export enum FormType {
    ADDRESS = 'address',
    LMS = 'lms',
};
